  <template>
  <v-dialog v-model="modal" max-width="800" persistent>
    <v-card>
      <v-form ref="form">
        <v-card-title>
          <v-tabs color="secondary" v-model="indexTab">
            <span
              class="am-t2 bold"
              style="
                align-self: center;
                display: inline-block;
                color: rgba(0, 0, 0, 0.87) !important;
              "
              >Membre fondateur</span
            >
            <v-tab :disabled="tabDisabled && indexTab !== 0">
              Personne physique
            </v-tab>
            <v-tab :disabled="tabDisabled && indexTab !== 1">
              Personne morale
            </v-tab>
          </v-tabs>
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <v-row dense v-if="indexTab === 0" key="phy">
                <v-col cols="12" md="3">
                  <a-civilite-select
                    dense
                    filled
                    label="Civilité"
                    v-model="civilite"
                    :rules="[requiredRule(), serverRule(`${prefix}.civilite`)]"
                    @input="clear(`${prefix}.civilite`)"
                    data-testid="civilite"
                  />
                </v-col>
                <v-col cols="12" md="5">
                  <v-text-field
                    dense
                    filled
                    label="Nom"
                    v-model.trim="nom"
                    :rules="[requiredRule(), serverRule(`${prefix}.nom`)]"
                    @input="clear(`${prefix}.nom`)"
                    data-testid="nom"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    dense
                    filled
                    label="Prénom"
                    v-model.trim="prenom"
                    :rules="[requiredRule(), serverRule(`${prefix}.prenom`)]"
                    @input="clear(`${prefix}.prenom`)"
                    data-testid="prenom"
                  />
                </v-col>
              </v-row>

              <v-row dense v-if="indexTab === 1" key="mor">
                <v-col cols="12" md="6">
                  <a-forme-juridique-combobox
                    dense
                    filled
                    label="Forme juridique"
                    v-model.trim="formeJuridique"
                    :rules="[
                      requiredRule(),
                      serverRule(`${prefix}.formeJuridique`),
                    ]"
                    @input="clear(`${prefix}.formeJuridique`)"
                    data-testid="forme-juridique"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    dense
                    filled
                    label="Dénomination"
                    v-model.trim="denomination"
                    :rules="[
                      requiredRule(),
                      serverRule(`${prefix}.denomination`),
                    ]"
                    @input="clear(`${prefix}.denomination`)"
                    data-testid="denomination"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn data-testid="valider-edition-fondateur" @click="valide" color="primary">Sauvegarder</v-btn>
          <v-btn data-testid="annuler-edition-fondateur" ref="non" @click="ferme">Annuler</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import makeMembreDialog from "./makeMembreDialog";

function mapPhysique(src, dest) {
  dest.civilite = src.civilite;
  dest.nom = src.nom;
  dest.prenom = src.prenom;
}

function mapMorale(src, dest) {
  dest.formeJuridique = src.formeJuridique;
  dest.denomination = src.denomination;
  dest.denomination = src.denomination;
}

export default {
  mixins: [makeMembreDialog(mapPhysique, mapMorale)],
};
</script>
